import React, { useEffect, useRef, useState } from "react";
import ReactPaginate from "react-paginate";

export default function PaginatedItems({
  total,
  pageNo,
  setPageNo,
  handlePageChange = () => {},
  pageSize = 50,
  displayTotal = total,
  className,
  responsive = false,
  compactMarginPagesDisplayed = 1,
  handlePageChangeInCompletionForm
}) {
  const itemsPerPage = pageSize;
  const pageCount = Math.ceil(total / itemsPerPage);
  const containerRef = useRef(null);
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    if (!responsive || !containerRef.current) return;
    const container = containerRef.current;
    const update = () => setCompact(container.clientWidth < 480);
    update();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", update);
      return () => window.removeEventListener("resize", update);
    }
    const observer = new ResizeObserver(update);
    observer.observe(container);
    return () => observer.disconnect();
  }, [responsive]);

  const handlePageClick = (event) => {
    handlePageChange(event.selected + 1);
   if (typeof handlePageChangeInCompletionForm === 'function') {
      handlePageChangeInCompletionForm(event.selected + 1);
    }
    setPageNo(event.selected + 1);
    
    // const newOffset = ((event.selected + 1) * itemsPerPage) % total;
  };

  return (
    <div ref={containerRef} className={`pagination-summary ${compact ? "pagination-summary-compact" : ""} ${className || ""}`}>
      <div className="pagination-summary-spacer"></div>
      <ReactPaginate
        className={"pagination"}
        previousClassName={`page-item first-page `}
        previousLinkClassName={`pagination-link ${
          pageNo === 1 ? "disabled" : ""
        }`}
        nextClassName={"page-item last-page"}
        nextLinkClassName={`pagination-link ${
          pageNo === pageCount ? "disabled" : ""
        }`}
        pageClassName={"page-item "}
        pageLinkClassName={"pagination-link"}
        activeLinkClassName={"active-page"}
        breakLabel="..."
        nextLabel={<i className="fa-solid fa-angle-right"></i>}
        onPageChange={handlePageClick}
        pageRangeDisplayed={compact ? 1 : 5}
        marginPagesDisplayed={compact ? compactMarginPagesDisplayed : 2}
        pageCount={pageCount}
        previousLabel={<i className="fa-solid fa-angle-left"></i>}
        renderOnZeroPageCount={null}
        forcePage={pageNo - 1}
      />
      <p className="pagination-total">
        Total Results: <b>{displayTotal}</b>
      </p>
    </div>
  );
}
